<template>
  <div>
    <log-panel :entity="'office'"></log-panel>
  </div>
</template>

<script>
import LogPanel from '../_components/LogPanel'
export default {
  name: 'OfficeLogPanel',
  components: { LogPanel },
  created () {
    this.$store.dispatch('LogsStore/clearStore')
    this.$store.dispatch('LogsStore/fetchLogs', 'office')
  }
}
</script>
